module.exports = __webpack_public_path__ + "static/garmin_cycling_coach-88b87a77bb8dac8f0901bccef77b2fd5.jpg";